import type { CertificateDetails } from '../models.js';

export const RENEWAL_WINDOW_DAYS = 30;

const DAY_MS = 86_400_000;

export function isAvailableForRenewal(
  {
    currentStatus,
    policyExpirationDate,
  }: Pick<CertificateDetails, 'currentStatus' | 'policyExpirationDate'>,
  today: Date = new Date(),
): boolean {
  if (currentStatus !== 'LIVE') {
    return false;
  }

  const expiry = new Date(policyExpirationDate);
  if (Number.isNaN(expiry.getTime())) {
    return false;
  }

  const untilExpiry = expiry.getTime() - today.getTime();
  return untilExpiry >= 0 && untilExpiry <= RENEWAL_WINDOW_DAYS * DAY_MS;
}
